import React from "react";
export const Tab = (props) => {
  return <Tab>{props.children}</Tab>;
};
